import React from "react";
import { me } from '@data/me'

const Social = () => {
    return (
        <div className="home__social">
            <a href={me.socialLinks.linkedin} className="home__social-icon" target="_blank" rel="noreferrer">
                <i className="uil uil-linkedin-alt"></i>
            </a>

            <a href={me.socialLinks.github} className="home__social-icon" target="_blank" rel="noreferrer">
                <i className="uil uil-github-alt"></i>
            </a>

            <a href={me.socialLinks.instagram} className="home__social-icon" target="_blank" rel="noreferrer">
                <i className="uil uil-instagram"></i>
            </a>
        </div>
    );
}

export default Social;